module.exports = __webpack_public_path__ + "vikatan-homeicon-cf63434a2ad9cbbceba8.png";